import { render, staticRenderFns } from "./AgentEditor.vue?vue&type=template&id=1c97fabd&scoped=true"
import script from "./AgentEditor.vue?vue&type=script&lang=js"
export * from "./AgentEditor.vue?vue&type=script&lang=js"
import style0 from "./AgentEditor.vue?vue&type=style&index=0&id=1c97fabd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c97fabd",
  null
  
)

export default component.exports